import { SummaryFeatureRuleMap, DisplayFeature, DisplayFeatureStatic } from '~pricing/lib/summaryPackages';
import { formatSummaryFeature } from '~app/pages/Pricing/lib/packageFeatures';

const SETTING_UNLIMITED = 'unlimited';

// Individual feature line rules
const SummaryFeatureRules: SummaryFeatureRuleMap = {
  survey_create_limit: () => formatSummaryFeature('survey_create_limit'),

  create_question_limit: ({ create_question_limit }) => {
    const setting = create_question_limit?.setting;
    const obj = setting === SETTING_UNLIMITED ? formatSummaryFeature('create_question_limit') : null;
    return obj;
  },

  response_count: ({ base_response_count, num_free_responses }, { locale }) => {
    let obj: DisplayFeatureStatic = {};

    // Annual packages
    if (base_response_count?.amount) {
      obj = formatSummaryFeature('base_response_count', { amount: base_response_count.amount.toLocaleString(locale) });

      // Basic/Standard monthly
    } else if (num_free_responses?.amount) {
      obj = formatSummaryFeature('num_free_responses', { amount: num_free_responses.amount.toLocaleString(locale) });

      // Enterprise
    } else if (num_free_responses?.setting === SETTING_UNLIMITED) {
      obj = formatSummaryFeature('unlimited_responses');
    }

    return obj;
  },

  support: ({ priority_email_support, phone_support }) => {
    let obj: DisplayFeatureStatic = {};

    // we'll check from highest level support to lowest
    if (phone_support?.isEnabled) {
      obj = formatSummaryFeature('phone_support');
    } else if (priority_email_support?.isEnabled) {
      obj = formatSummaryFeature('priority_email_support');
    } else {
      obj = formatSummaryFeature('email_support');
    }

    return obj;
  },

  quizzes_pro: ({ quizzes_pro }) => (quizzes_pro?.isEnabled ? formatSummaryFeature('quizzes_pro') : null),

  analyze_export_enabled: ({ analyze_export_enabled }) =>
    analyze_export_enabled?.isEnabled ? formatSummaryFeature('analyze_export_enabled') : null,

  survey_logic: ({ create_skip_logic_enabled, create_piping_enabled }) => {
    let obj: DisplayFeature = {};

    if (create_piping_enabled?.isEnabled) {
      obj = formatSummaryFeature('create_piping_enabled');
    } else if (create_skip_logic_enabled?.isEnabled) {
      obj = formatSummaryFeature('create_skip_logic_enabled');
    }

    return obj;
  },

  statistical_significance: ({ statistical_significance }) => formatSummaryFeature('statistical_significance'),

  survey_branding: ({ create_logo_enabled, create_custom_theme_enabled, collector_friendly_url_enabled }) => {
    const hasBranding =
      create_logo_enabled?.isEnabled &&
      create_custom_theme_enabled?.isEnabled &&
      collector_friendly_url_enabled?.isEnabled;
    return hasBranding ? formatSummaryFeature('survey_branding') : null;
  },

  analyze_export_spss_enabled: ({ analyze_export_spss_enabled }) =>
    analyze_export_spss_enabled?.isEnabled ? formatSummaryFeature('analyze_export_spss_enabled') : null,

  create_advanced_features: ({ create_quotas_enabled, a_b_testing, create_randomization_enabled }) => {
    const hasAdvancedFeatures =
      create_quotas_enabled?.isEnabled && a_b_testing?.isEnabled && create_randomization_enabled?.isEnabled;

    return hasAdvancedFeatures ? formatSummaryFeature('advanced_survey_features') : null;
  },

  create_custom_variables_enabled: ({ create_custom_variables_enabled }) =>
    create_custom_variables_enabled?.isEnabled ? formatSummaryFeature('create_custom_variables_enabled') : null,

  payment_qt: ({ payment_qt }) => (payment_qt?.isEnabled ? formatSummaryFeature('payment_qt') : null),

  file_upload: ({ file_upload }) => (file_upload?.isEnabled ? formatSummaryFeature('file_upload') : null),

  benchmarks: ({ benchmarks }) => (benchmarks?.isEnabled ? formatSummaryFeature('benchmarks') : null),

  click_map_qt: ({ click_map_qt }) => (click_map_qt?.isEnabled ? formatSummaryFeature('click_map_qt') : null),
};

export default SummaryFeatureRules;
